import { render, staticRenderFns } from "./appliance-type-add-or-update.vue?vue&type=template&id=6a76173d"
import script from "./appliance-type-add-or-update.vue?vue&type=script&lang=js"
export * from "./appliance-type-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports